import { useState, useEffect, useCallback } from "react";

export const usePersistentState = <T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  // Stato locale per il dato
  const [state, setState] = useState<T>(() => {
    const storedValue = localStorage.getItem(key);
    return storedValue ? (JSON.parse(storedValue) as T) : initialValue;
  });

  // Funzione per aggiornare il valore
  const setValue = useCallback(
    (value: T) => {
      setState(value);
      localStorage.setItem(key, JSON.stringify(value)); // Persistenza
      // Notifica manuale ad altre app, se necessario
      window.dispatchEvent(new Event("storage")); // Forza l'evento per triggerare gli ascoltatori
    },
    [key]
  );

  // Effetto per ascoltare le modifiche al dato (anche da altre app)
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === key && event.newValue !== null) {
        setState(JSON.parse(event.newValue) as T);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [key]);

  return [state, setValue];
};
